import queryString from 'query-string';

// eslint-disable-next-line no-restricted-globals
export const parseQueryString = (string: string = location.search) => {
  return queryString.parse(string);
};
